import { createAction } from 'redux-actions';

export const openModal = createAction('OPEN_MODAL');
export const closeModal = createAction('CLOSE_MODAL');
export const chageModal = createAction('CHANGE_MODAL');
export const setModalMsg = createAction('SET_MODAL_MSG')


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/ModalAction.jsx